import BackToTop from '@elem/compCommon/BackToTop';
import { createPortal } from 'react-dom';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic() {
    const { useState, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <EmailSubscribe locale="jp" className="email-subscribe" pageType={PAGE_TYPE.Camp} entry_position={6} />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            {isClient && createPortal(<BackToTop />, document.body)}
        </>
    );
}
